// Module
var code = "<search></search> <announcements></announcements> <menu></menu> <div block-ui=root class=root> <ui-view></ui-view> </div> ";
// Exports
module.exports = code;